import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { CheckinHttpClient } from 'src/app/shared/services/http/http-client.service';
import { EnvService } from 'src/app/shared/common/services/env.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { ControlsConfig } from '../../models/form/controls.model';
import { EControlsType, EControls } from '../../enums/controls.enum';
import * as i0 from "@angular/core";
var FormService = /** @class */ (function () {
    function FormService() {
        this.issuedAtEntityByCountry = {
            PT: 'country'
        };
        this.issuedAtLabelByCountry = {
            PT: 'country-issued-in'
        };
        this.issuedAtTypeByCountry = {
            PT: EControlsType.SELECT
        };
        var injector = InjectorService.get();
        this.config = injector.get(ConfigService);
        var env = injector.get(EnvService);
        Object.assign(this, {
            http: injector.get(CheckinHttpClient),
            url: env.endpoint + "/v2/config/checkin/form/" + this.config.checkin.hash
        });
    }
    FormService.prototype.get = function (guestId) {
        var _this = this;
        return this.http.get(this.url + "/" + guestId).pipe(map(function (res) { return _this.sanitize(res.form); }), catchError(function (error) { throw error; }));
    };
    FormService.prototype.update = function (guestId, controls) {
        var _this = this;
        return this.http.put(this.url + "/" + guestId, controls).pipe(map(function (res) { return res.form ? _this.sanitize(res.form) : res.ok; }), catchError(function (error) { throw error; }));
    };
    FormService.prototype.close = function (guestId, params) {
        return this.http.patch(this.url + "/" + guestId, params).pipe(map(function (res) { return res.ok; }), catchError(function (error) { throw error; }));
    };
    FormService.prototype.sanitize = function (controls) {
        var _this = this;
        if (!Array.isArray(controls) || controls.length === 0) {
            return {};
        }
        return controls.reduce(function (acc, _a) {
            var _b;
            var id = _a.id, value = _a.value, required = _a.required, order = _a.order, c = tslib_1.__rest(_a, ["id", "value", "required", "order"]);
            var type = ControlsConfig[id].type;
            if (type === EControlsType.AUTOSUGGEST) {
                if (!value || (typeof value === 'object' && !value.hasOwnProperty('value'))) {
                    value = {
                        value: ''
                    };
                }
            }
            if (type === EControlsType.DATE && value) {
                value = new Date(value);
            }
            if (id === EControls.clientNationality) {
                value = typeof value !== 'number' ? '' : value;
            }
            if (id === EControls.clientIdIssuedAt && _this.config.booking.acc.country.code === 'PT') {
                ControlsConfig[id].entity = _this.issuedAtEntityByCountry[_this.config.booking.acc.country.code] || 'city';
                ControlsConfig[id].label = _this.issuedAtLabelByCountry[_this.config.booking.acc.country.code] || 'issued-in';
                ControlsConfig[id].type = _this.issuedAtTypeByCountry[_this.config.booking.acc.country.code] || EControlsType.AUTOSUGGEST;
                ControlsConfig[id].service = 'countries';
            }
            return tslib_1.__assign({}, acc, (_b = {}, _b[id] = tslib_1.__assign({}, ControlsConfig[id], c, { id: id,
                value: value,
                required: required,
                order: order }), _b));
        }, {});
    };
    FormService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormService_Factory() { return new FormService(); }, token: FormService, providedIn: "root" });
    return FormService;
}());
export { FormService };
